/*
 * Copyright (C) 2020 Robert Bosch GmbH Copyright (C) 2020 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { InjectionToken } from "@angular/core";

export const defaultPlaceholder = "–";

export const NO_VALUE_PLACEHOLDER = new InjectionToken<string>(
  "NO_VALUE_PLACEHOLDER"
);
